import { DateTime } from 'luxon';

import * as types from 'generated/graphql';

import { dateTimeFieldPolicy } from 'modules/common/layer01/apolloClient/cache/typePolicies/fieldPolicies';

import { ITypeSpecificPolicy } from 'modules/common/layer01/apolloClient/cache/typePolicies/shared';



export const Task: ITypeSpecificPolicy<types.Task> = {
  fields: {
    dueDate: dateTimeFieldPolicy(),
    createdAt: dateTimeFieldPolicy(),

    isOverdue: {
      read: (_, { readField }) => {

        const value = readField<DateTime>('dueDate');

        if (!value) {
          return false;
        }

        const diff = value.diffNow().as('seconds');

        return diff < 0;
      }
    },
    isComplete: {
      read: (_, { readField, isReference }) => {

        const value = readField<unknown[]>('status');

        if (!value) {
          return false;
        }
        const isRef = isReference(value);
        if (!isRef) {
          return false;
        }
        const statusName = readField<types.TaskStatusName>('name', value);

        if (statusName === 'complete') {
          return true;
        }
        return false;
      }
    }
  }
};
